export const RouteTransitions = {
  Fade: 'app-transition-fade',
} as const
